//@flow
/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import {
    Text,
    Flex,
    Box,
    Icon,
    Stack,
    Columns,
    Column
} from '@locus-taxy/neo-ui';
import { type TFunction } from 'react-i18next';

type Props = {
    legendMap: Map<string, Object>,
    isMapOptionsOpen: boolean,
    getContainer: () => void,
    t: TFunction
};

const FpPlanViewLegends = (props: Props) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const onToggleView = isOpen => !isOpen;

    const { legendMap, t } = props;

    const Legends = legendMap
        .map((legendColor, key) => {
            return (
                <Box p={1} key={key}>
                    <Columns width="fluid" align="center" alignY="center">
                        <Column width="1/4">
                            <Icon icon="circle" color={legendColor.code} />
                        </Column>
                        <Column width="fluid">
                            <Text color="white">{key}</Text>
                        </Column>
                    </Columns>
                </Box>
            );
        })
        .toArray();

    return (
        <Box height={isOpen ? '15rem' : '3rem'}>
            <Stack>
                <Flex
                    height={32}
                    alignItems="center"
                    px={2}
                    py={1}
                    bg="black"
                    width="20rem"
                    sx={{
                        cursor: 'pointer',
                        borderRadius: '0.5rem',
                        borderBottomLeftRadius: isOpen ? 0 : '0.5rem',
                        borderBottomRightRadius: isOpen ? 0 : '0.5rem'
                    }}
                    onClick={() => {
                        setIsOpen(onToggleView);
                    }}
                >
                    <Box>
                        <Icon
                            color="white"
                            icon={
                                isOpen ? 'arrow_drop_down' : 'arrow_drop_right'
                            }
                        />
                    </Box>
                    <Box px={2} width="20rem">
                        <Text fontSize={0} color="white">
                            {t('fpPlanView.legends')}
                        </Text>
                    </Box>
                </Flex>

                <Box
                    p={1}
                    bg="black"
                    width="20rem"
                    height="12rem"
                    sx={{
                        display: isOpen ? 'block' : 'none',
                        visibility: isOpen ? 'visible' : 'hidden',
                        opacity: isOpen ? 1 : 0,
                        borderBottomLeftRadius: '0.5rem',
                        borderBottomRightRadius: '0.5rem',
                        overflowY: 'scroll',
                        overflowX: 'hidden',
                        maxHeight: '12rem',
                        transition: '0.5s ease opacity'
                    }}
                >
                    <Stack>{Legends}</Stack>
                </Box>
            </Stack>
        </Box>
    );
};

export default FpPlanViewLegends;
